import { render, staticRenderFns } from "./DialogDeleteRelatoriosPadroes.vue?vue&type=template&id=29bb1172"
import script from "./DialogDeleteRelatoriosPadroes.vue?vue&type=script&lang=js"
export * from "./DialogDeleteRelatoriosPadroes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports